import { render, staticRenderFns } from "./serveCompanyDetailSecondDialog.vue?vue&type=template&id=619f8976&scoped=true&"
import script from "./serveCompanyDetailSecondDialog.vue?vue&type=script&lang=js&"
export * from "./serveCompanyDetailSecondDialog.vue?vue&type=script&lang=js&"
import style0 from "./serveCompanyDetailSecondDialog.vue?vue&type=style&index=0&id=619f8976&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619f8976",
  null
  
)

export default component.exports